export default __webpack_public_path__ + "static/media/jumbotronBg.ee37dfca.png";